import React, { useRef } from "react";
import RoughBorder from "../kits/LayoutKit/RoughBorder";

const CardBox = ({ children, className = "", ...rest }) => {
  const ref = useRef(null);
  return (
    <div
      ref={ref}
      className={`
        relative 
        bg-white/50 
        shadow 
        p-6 flex 
        flex-col 
        justify-center 
        items-center 
        min-h-[160px] 
        md:min-h-[190px] 
        rounded-md
        ${className}`}
      {...rest}
    >
      {children}
      <RoughBorder 
      parentRef={ref} 
      color="#AC8E66" 
      radius={16} 
      strokeWidth={0.3}
      roughness={1.1}
      bowing={2}
      />
    </div>
  );
};

export default CardBox;